import { createPatchEndpoint } from '@sonar-software/sonar-http';
import { MonitorFormTypes } from '@types';

export type PatchDataSecurityMonitorByIdRequest =
	Omit<MonitorFormTypes, 'applicationId' | 'templateId' | 'applicationIds'>;

export const patchDataSecurityMonitorById = createPatchEndpoint<PatchDataSecurityMonitorByIdRequest>(
	(request) => `/api/v3/data-security/monitors/${request.id}`
);
